<template>
  <span>
    {{textlabel}} <a-checkbox
      v-model="checkboxval"
      @change="handlecheckboxAllchecked"
      :checked="checked"
      :disabled="disabled"
    ></a-checkbox>
  </span>
</template>

<script>
export default {
  name: "CheckboxSelectAll",
  props: {
    data_table: [],
    textlabel: String,
  },
  data() {
    return {
      checkboxval: false,
      checked: false,
      disabled: true,
    };
  },
  computed: {
  },
  methods: {
    setvalcheckboxall(val){
      this.checkboxval = val;
      this.checked = val;
    },
    setdisabledcheckboxall(val){
      this.disabled = val;
    },
    handlecheckboxAllchecked(){
      Event.$emit("checkboxallselectReturn", this.checkboxval);
    }
  },
  mounted() {
    Event.$on("setvalcheckboxallselect", this.setvalcheckboxall);
    Event.$on("setdisabledcheckboxallselect", this.setdisabledcheckboxall);
  },
  beforeDestroy() {
    Event.$off("setvalcheckboxallselect", this.setvalcheckboxall);
    Event.$off("setdisabledcheckboxallselect", this.setdisabledcheckboxall);
  }
};
</script>

<style>
</style>